import { axiosAuthInstance } from '~/api'
import { Profile } from '~/model'

export function setupBookmarklets() {
	setupResetOnboardedBookmarklet()
}

declare global {
	interface Window {
		resetOnboardedStatus: () => Promise<void>
	}
}

function setupResetOnboardedBookmarklet() {
	window.resetOnboardedStatus = async () => {
		try {
			const { data: profile } = await axiosAuthInstance.get<{ user: Profile }>('/user/me')
			profile.user.appData.ailearningassistant.onboarded = false
			await axiosAuthInstance.put<{ user: Profile }>('/user/me', { user: profile.user })
			window.location.reload()
		} catch (error) {
			alert('Failed to reset onboarding status')
			console.error(error)
		}
	}
}
